"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserData = void 0;
var react_intl_1 = require("react-intl");
var types_1 = require("./types");
var utils_1 = require("./utils");
var messages_1 = require("../../messages");
var menuMessages = messages_1.commonMessages.menu;
var useUserData = function (_a) {
    var user = _a.user, isDataAndPrivacyPageEnabled = _a.isDataAndPrivacyPageEnabled, handleLogOut = _a.handleLogOut;
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    var userData = {
        email: user.email,
        username: "".concat(user.firstName, " ").concat(user.lastName),
        profileImageUrl: user.profileImageUrl,
        basePath: types_1.EAuthRoutes.USER,
        items: __spreadArray(__spreadArray([
            {
                key: 'log-in-and-security',
                label: formatMessage(menuMessages.logInAndSecurity),
                to: "".concat(types_1.EAuthRoutes.USER).concat(types_1.EAuthRoutes.LOGIN_AND_SECURITY),
                testId: 'sidebar-log-in-and-security',
            },
            {
                key: 'personal-data',
                label: formatMessage(menuMessages.personalData),
                to: "".concat(types_1.EAuthRoutes.USER).concat(types_1.EAuthRoutes.PERSONAL_DATA),
                testId: 'sidebar-personal-data',
            },
            {
                key: 'business-information',
                label: formatMessage(menuMessages.businessAccounts),
                to: types_1.EAuthRoutes.USER_BUSINESS_ACCOUNTS,
                testId: 'sidebar-business-information',
            }
        ], (0, utils_1.useDataAndPrivacySidbarItem)(isDataAndPrivacyPageEnabled), true), [
            {
                label: formatMessage(menuMessages.logout),
                testId: 'sidebar-logout',
                onClick: handleLogOut,
                key: 'logout',
            },
        ], false),
    };
    return userData;
};
exports.useUserData = useUserData;
